<template>
  <InfoCard :title="title">
    <div
      class="documents-section"
      data-qa="documents_section"
    >
      <CoreImageLightbox
        v-if="!isMobile"
        ref="lightboxRef"
        :items="items"
      />

      <div
        v-if="!isMobile"
        class="documents-section__grid d-flex flex-wrap"
        data-qa="documents_section_grid"
      >
        <DocumentCard
          v-for="(item, index) in items"
          :key="item.id ?? `${item.src}-${index}`"
          :item="item"
          class="documents-section__card ma-4 ml-0 mt-0"
          @open="open(index)"
        />
      </div>

      <CoreImageSlider
        v-else
        :items="items"
        :has-navigation="items.length > 1"
        :has-pagination="items.length > 1"
        class="documents-section__slider"
        data-qa="documents_section_slider"
      >
        <template #item="{ item, open: openSlide }">
          <article
            class="documents-section__slider-item"
            data-qa="documents_section_slider_item"
            :data-qa-id="item.id"
          >
            <button
              type="button"
              class="documents-section__slider-button"
              data-qa="documents_section_slider_button"
              @click="openSlide()"
            >
              <img
                class="documents-section__slider-image w-100"
                :src="item.previewSrc || item.src"
                :alt="item.alt || item.title || ''"
                :title="item.title || undefined"
                loading="lazy"
              >
            </button>
            <div class="text-body-2 text-secondary--text text-center mt-3">
              {{ item.title }}
            </div>
          </article>
        </template>
      </CoreImageSlider>

      <p
        v-if="updatedDate"
        class="text-body-2 text-info--text text-right mt-2 mb-0"
        data-qa="documents_section_updated_date"
      >
        {{ updatedDate }}
      </p>
    </div>
  </InfoCard>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import InfoCard from 'src/components/pages/info/about-us/index/components/MainContent/components/InfoCard.vue'
import CoreImageLightbox from 'src/core/CoreImageLightbox/CoreImageLightbox.vue'
import CoreImageSlider from 'src/core/CoreImageSlider/CoreImageSlider.vue'
import DocumentCard from 'src/components/pages/info/document/index/components/DocumentCard.vue'
import type { DocumentItem } from 'src/components/pages/info/document/index/types'

type LightboxExpose = {
  open: (_index: number) => void
}

defineProps<{
  title: string
  items: DocumentItem[]
  isMobile: boolean
  updatedDate?: string
}>()

const lightboxRef = ref<LightboxExpose | null>(null)

function open(index: number) {
  lightboxRef.value?.open(index)
}
</script>

<style scoped lang="scss">
.documents-section {
  &__slider-button {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }

  &__slider-image {
    border-radius: 20px;
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }
}

@media screen and (max-width: 1200px) {
  .documents-section__grid {
    justify-content: center;
  }
}
</style>
